<script lang="ts">
  export let subtitle: string;
  export let title: string;
  export let description: string;
  export let numberOfInjectedComponents: number;

  const headerSectionClass: string = numberOfInjectedComponents > 1 ? 'h-50' : 'h-40';
</script>

<div class={headerSectionClass}>
  <p class="card-subtitle">{subtitle}</p>
  <h2 class="card-title mb-1">{title}</h2>
  {#if description}
    <p class="m-0">{@html description}</p>
  {/if}
  <slot />
</div>

<style>
  h2 {
    font-size: 1.6rem;
  }

  .h-40 {
    height: 40%;
  }
</style>
